import {ChangeEvent, FC} from 'react';
import {
	formatTaxIdentifierDisplay,
	normalizeTaxIdentifier,
	TAX_IDENTIFIER_SUBTITLE,
	TaxIdentifierStepValues,
} from '../../model';
import {StepLayout} from 'features/registration';
import {TextInput} from '../components/TextInput';
import styles from './TaxIdentifierStep.module.css';

type Props = {
	values: TaxIdentifierStepValues;
	error?: string | null;
	onChange: (patch: Partial<TaxIdentifierStepValues>) => void;
};

export const TaxIdentifierStep: FC<Props> = ({values, error, onChange}) => {
	const handleChange = (event: ChangeEvent<HTMLInputElement>) => {
		onChange({taxIdentifier: normalizeTaxIdentifier(event.target.value)});
	};

	return (
		<StepLayout variant="fill">
			<StepLayout.Intro
				title="Введите Налоговый идентификатор"
				subtitle={TAX_IDENTIFIER_SUBTITLE}
				compact
				subtitleMuted
			/>

			<StepLayout.Content className={styles.field}>
				<TextInput
					name="taxIdentifier"
					className={styles.input}
					value={formatTaxIdentifierDisplay(values.taxIdentifier)}
					placeholder="0000 0000 0000"
					autoComplete="off"
					aria-invalid={Boolean(error)}
					onChange={handleChange}
					onClear={() => onChange({taxIdentifier: ''})}
				/>
				{error ? <p className={styles.error}>{error}</p> : null}
			</StepLayout.Content>
		</StepLayout>
	);
};
